var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contacts-form',{model:{value:(_vm.contactInfo),callback:function ($$v) {_vm.contactInfo=$$v},expression:"contactInfo"}})}
var staticRenderFns = []

export { render, staticRenderFns }